import {createContext, useContext} from 'react';
import { AllCollectionsDeanteData, AllColorBadgesData, AllDeanteData, AllUnitDeanteData, AllVariantGroupsData, catalogTypes, PorfolioList } from './AppProvider';
import { dealer } from '../../../WhereToBuy/Interfaces/Interface';
import { OTHER_INFO_FIELDS_PROPS } from '../../../Account/Components/interfaces';

export interface DefaultJSON {
    [key: string]: any 
}



export interface ModalWindowProps{
    enabled: boolean
    ModalWindow: React.ReactNode | null
}

const defaultValue = {
    deviceType: 'ios',
    isWeb: false,
    isIOS: false,
    scaleAll: 1,
    currentHeight: 0,
    currentWidth: 0,
    refWidth: 0,
    refHeight: 0,

    ACCESS_TOKEN: '',
    setACCESS_TOKEN: (token: '') => {},
    X_API_TOKEN: '',
    setX_API_TOKEN: (token: '') => {},

    allUnitData: null as AllUnitDeanteData | null, setAllUnitData:(x: AllUnitDeanteData | null) => {},

    allCollectionsData: null as AllCollectionsDeanteData | null, setAllCollectionsData:(x: AllCollectionsDeanteData | null) => {},
    variantGroupsData: null as AllVariantGroupsData | null, setVariantGroupsData: (x: AllVariantGroupsData | null) => {},
    color_badges: null as AllColorBadgesData | null, setColorBadges: (x: AllColorBadgesData | null) => {},
    aboutData: null as AllDeanteData['about'] | null, setAboutData: (x: AllDeanteData['about'] | null) => {},
    instructionsData: null as AllDeanteData['instructions'] | null, setInstructionsData: (x: AllDeanteData['instructions'] | null) => {},
    sortOrderData: [] as string[], setSortOrderData: (x: string[]) => {},
    setBootstrapData: (x: AllDeanteData | null) => {},
    
    catalog_Types: [] as catalogTypes[], setCatalogTypes: (x: catalogTypes[]) => {},
    
    ModalWindow: {
        enabled: false,
        ModalWindow: null
    } as ModalWindowProps,
    setModalWindow: (ModalWindow: ModalWindowProps) => {},
    isSmallVersion: false, setSmallVersion: (x: boolean) => {},

    isMediumVersion: false, setMediumVersion: (x: boolean) => {},

    isTooBigVersion: false, setTooBigVersion: (x: boolean) => {},

    isTooSmall: false , setIsTooSmall: (x: boolean) => {},

    leftSlideOut: false, setLeftSlideOut: (x: boolean) => {},

    showDiscountedPrices: false as boolean, setShowDiscountedPrices: (x: boolean) => {},
    
    SearcherUnit: null as any | null, setSearcherUnit: (x: any | null) => {},
    setSearchBarTopActive: (x: boolean) => {},
    SearchBarTopActive: false as boolean,

    dealersList: [] as dealer[],
    setDealers: (x: dealer[]) => {},

    portfolioList: [] as PorfolioList[], setPortfolioList: (x: PorfolioList[]) => {},
    USER: null as USER_INTERFACE | null, setUSER: (x: null | USER_INTERFACE) => {},
    OTHER_INFO_FIELDS: null as OTHER_INFO_FIELDS_PROPS[] | null, setOTHER_INFO_FIELDS: (x: OTHER_INFO_FIELDS_PROPS[] | null) => {}
}
 

export interface USER_INTERFACE {
        'access_token': string,
        'role': string
    }

const AppContext = createContext(defaultValue);

export const useAppContext = () => {   
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useAppContext must be used within an AppContext.Provider');
    }
    return context;
}


export default AppContext;
